import React from "react";

import SectionHeadings from "@/components/Cred/UI/CredSectionHeadings";
import { ProtocolCard } from "@/components/Cred/Home/Summary/ProtocolCard";
import CredSection from "@/components/Cred/UI/CredSection";

interface CredHomeProtocolProps {
  currentSeason: number;
  daysLeft?: number;
  totalParticipants: number;
  totalCredEarned: number;
  isLoading?: boolean;
}

export default function CredHomeProtocol({ currentSeason, daysLeft, totalCredEarned, totalParticipants, isLoading }: CredHomeProtocolProps) {
  return (
    <CredSection>
      <SectionHeadings
        heading={isLoading ? <div className="h-8 w-48 animate-pulse rounded-md bg-neutral-200" /> : `Season ${currentSeason} stats`}
        subheading={isLoading ? <div className="h-4 w-32 animate-pulse rounded-md bg-neutral-200" /> : (daysLeft ?? 0) > 0 ? <p>Days Left: {daysLeft}</p> : <p>Season finished</p>}
      />

      <div className="grid grid-cols-1 gap-y-3 md:grid-cols-2 md:gap-x-4">
        <ProtocolCard value={totalParticipants} subtitle="Total Participants" isLoading={isLoading} />
        <ProtocolCard value={totalCredEarned} subtitle="Total CRED Earned" isLoading={isLoading} />
      </div>
    </CredSection>
  );
}
